export enum ButtonType {
    Submit = 'submit',
  }
  
  export enum ButtonRuleType {
    Primary = 'primary',
    Secondary = 'secondary',
  }